import { ArrowLeft, CircleCheck } from "lucide-react";
import { motion } from "motion/react";
import { useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/Button";
import { Card } from "../components/ui/Card";
import { useCart } from "../context/CartContext";
import { whatsappLink } from "../data/site";
import type { SuccessLocationState } from "../types";
import { formatPrice } from "../utils/format";

const Sucesso = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { clearCart } = useCart();

  const state = location.state as SuccessLocationState | null;
  const orderId = state?.orderId ?? "Novo Pedido";

  useEffect(() => {
    clearCart();
  }, [clearCart]);

  const handleOpenWhatsapp = () => {
    const mensagem = `Olá! Gostaria de acompanhar o meu pedido #${orderId} no Ninja Burger. 🍔`;
    window.open(whatsappLink(mensagem), "_blank", "noopener,noreferrer");
  };

  return (
    <section className="relative isolate overflow-hidden px-4 pb-24 pt-32 sm:px-6 lg:pt-40">
      <div aria-hidden="true" className="absolute left-1/2 top-24 -z-10 size-[520px] -translate-x-1/2 rounded-full bg-primary/10 blur-[120px]" />

      <Card className="mx-auto max-w-xl p-8 text-center sm:p-12">
        <motion.span
          initial={{ scale: 0, rotate: -90 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 16, delay: 0.2 }}
          className="mx-auto grid size-20 place-items-center rounded-full bg-success/15 text-success"
        >
          <CircleCheck className="size-11" aria-hidden="true" />
        </motion.span>

        <h1 className="mt-6 font-display text-6xl leading-none tracking-wide">
          Pedido <span className="text-primary">Recebido!</span>
        </h1>
        <p className="mt-4 text-muted">
          Obrigado por escolher o <strong className="text-white">Ninja Burger</strong>. Seu pedido{" "}
          <strong className="text-white">#{orderId}</strong> já está sendo preparado.
        </p>
        {state?.total !== undefined && (
          <p className="mt-3 text-sm text-muted">
            Total: <strong className="text-primary">{formatPrice(state.total)}</strong>
            {state.discount ? <span className="text-success"> (desconto de {formatPrice(state.discount)})</span> : null}
          </p>
        )}

        <div className="mt-8 rounded-2xl border border-line bg-night p-6 text-left">
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-primary">O que acontece agora?</span>
          <ul className="mt-3 space-y-2 text-sm text-muted">
            <li>• Você receberá notificações automáticas no seu WhatsApp.</li>
            <li>• O tempo estimado de entrega é de 30-50 min.</li>
            <li>• Fique de olho no seu celular! 📱</li>
          </ul>
        </div>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button
            onClick={handleOpenWhatsapp}
            icon={<FaWhatsapp className="size-4" aria-hidden="true" />}
            iconPosition="left"
            className="!bg-success hover:!bg-success/90"
          >
            Falar com Atendente
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate("/")}
            icon={<ArrowLeft className="size-4" aria-hidden="true" />}
            iconPosition="left"
          >
            Fazer outro pedido
          </Button>
        </div>
      </Card>
    </section>
  );
};

export default Sucesso;
